import { deleteClient } from "../api"

const deleteClientUseCase = client => {
    return deleteClient(client.id)
}

export default deleteClientUseCase